import styled from 'styled-components';

import FlexRow from '../ui/FlexRow';

const UnassignedRow = styled(FlexRow)`
  height: 100%;
  background-color: #d7e6ee;
`;

export default UnassignedRow;
